module.exports = __webpack_public_path__ + "img/txt.af53b2a7.png";